module.exports = __webpack_public_path__ + "img/ppt-icon.1f131f7a.png";